import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaBook, FaTachometerAlt, FaUser, FaTruck, FaUsers } from 'react-icons/fa';
import '../../css/Admin.css';

const SideMenu = () => {
  const location = useLocation();

  const menuItems = [
    { to: '/admin/bookings', icon: FaBook, label: 'Bookings' },
    { to: '/admin/users', icon: FaUsers, label: 'Users' },
    { to: '/admin/drivers', icon: FaTruck, label: 'Drivers' },
    { to: '/me/profile', icon: FaUser, label: 'Profile' },
  ];

  const isActive = (to) =>
    to === '/me/profile'
      ? location.pathname === to
      : location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <div className="sidebar">
      <Nav className="flex-column">
        <div className="sidebar-brand">
          <FaTachometerAlt className="me-2" /> MBZ Admin
        </div>
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <Nav.Link
              as={Link}
              to={item.to}
              key={item.to}
              className={`sidebar-link ${isActive(item.to) ? 'active' : ''}`}
            >
              <Icon className="menu-icon" />
              <span>{item.label}</span>
            </Nav.Link>
          );
        })}
      </Nav>
    </div>
  );
};

export default SideMenu;
